__webpack_require__.hmrF = function() { return "scripts." + __webpack_require__.h() + ".hot-update.json"; };